// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2AhnV","question":"Question_question__1vGHl","description":"Question_description__2WoeG"};